import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const PrivyWaitingLazy = lazyLoader(
  () => import('./PrivyWaiting' /* webpackChunkName: "loan-privy-waiting" */),
);

const PrivyWaiting = () => {
  return (
    <Suspense fallback={null}>
      <PrivyWaitingLazy />
    </Suspense>
  );
};

export default PrivyWaiting;
